const LOCAL_STORAGE = {
    CREDENTIALS_NAMESPACE: {
        PAGE_COUNT: "credentialsPageCount"
    }
}

export default LOCAL_STORAGE;